import React from 'react'
import PropTypes from 'prop-types'

class Battery extends React.Component {

  render () {
    const { size, level, color, bgColor } = this.props
    const rate = 64 * level / 100
    const pos = 174 + (64 - rate)
    const styles = {
      top : {
        fill: bgColor,
      },
      body: {
        fill: 'none',
        stroke: bgColor,
        strokeWidth: 8
      },
      rate: {
        fill: color,
      }
    }

    return (
      <svg width={size} height={size} viewBox="0 0 120 120">
        <g transform="translate(-102,-140)">
          <rect style={styles.top} width="25" height="8"
            x="150" y="152" rx="0.1" ry="0.1" />
          <rect style={styles.body} width="52" height="80"
            x="136" y="166" rx="0.1" ry="0.1" />
          <rect style={{fill: color}} width="36" height={rate}
            x="144" y={pos} rx="0.1" ry="0.1" />
        </g>
      </svg>
    )
  }
}

Battery.propTypes = {
  size:     PropTypes.number,
  level:    PropTypes.number,
  color:    PropTypes.string,
  bgColor:  PropTypes.string,
}

Battery.defaultProps = {
  size: 36,
  level: 100,
  color: 'darkgreen',
  bgColor: '#666',
}

export default Battery



// WEBPACK FOOTER //
// ./src/components/widgets/Battery.js